<template>
  <v-app id="sandbox">
    <v-navigation-drawer
      v-model="drawer.model"
      app
      overlay-color="deep-purple lighten-4"
      color="appDrawerBg"
      :permanent="false"
      right
      temporary
    >
      <v-list 
        dense
        nav
        subheader
      >
        <v-subheader class="appDrawerTx--text">Navigation</v-subheader>

        <v-list-item tag="router-link" to="/">
          <v-list-item-icon>
            <v-icon color="appDrawerTx">mdi-view-dashboard</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="appDrawerTx--text">Store home</v-list-item-title>
          </v-list-item-content> 
        </v-list-item>

        <v-list-item tag="router-link" to="/about">
          <v-list-item-icon>
            <v-icon color="appDrawerTx">mdi-store</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="appDrawerTx--text">About Us</v-list-item-title>
          </v-list-item-content> 
        </v-list-item>

        <v-list-item tag="router-link" to="/delivery">
          <v-list-item-icon>
            <v-icon color="appDrawerTx">mdi-truck-fast</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="appDrawerTx--text">Delivery</v-list-item-title>
          </v-list-item-content> 
        </v-list-item>

        <v-list-item tag="router-link" to="/returns">
          <v-list-item-icon>
            <v-icon color="appDrawerTx">mdi-keyboard-return</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="appDrawerTx--text">Returns</v-list-item-title>
          </v-list-item-content> 
        </v-list-item>

        <v-list-item tag="router-link" to="/privacy">
          <v-list-item-icon>
            <v-icon color="appDrawerTx">mdi-medal</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="appDrawerTx--text">Privacy</v-list-item-title>
          </v-list-item-content> 
        </v-list-item>
      </v-list>

      <template v-slot:append>
        <div class="pa-2">
          <v-btn tag="router-link" to="/admin" color="primary" block v-if="isLoggedIn">
            <v-icon left>mdi-security</v-icon>
            Admin
          </v-btn>
          <v-divider
            vertical
          ></v-divider>
          <v-btn color="secondary" block @click.prevent="logout" v-if="isLoggedIn">
            <v-icon left>mdi-exit-to-app</v-icon>
            Logout
          </v-btn>
          <v-btn v-else tag="router-link" to="/login" color="secondary" block>Admin Login</v-btn>

        </div>
      </template>
    </v-navigation-drawer>

    <v-app-bar
      app
      color="appBarBg"
    >
      <v-app-bar-nav-icon
        color="appBarTx"
        @click.stop="drawer.model = !drawer.model"
      />
      <v-toolbar-title class="appBarTx--text">
        Online Store
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-menu 
        left 
        bottom 
        close-on-click
        :nudge-width="120"
        offset-y
        transition="slide-y-transition"
        v-if="['home'].indexOf($route.name) > -1"
      >
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            small
            :disabled="!cart.items"
          >
            My Cart
          </v-btn>
        </template>
        <v-list
          dense
          flat
          nav
        >
          <v-list-item @click="displayCart">
            <v-list-item-title>View cart</v-list-item-title>
          </v-list-item>
          <v-list-item @click="resetCart">
            <v-list-item-title>Empty cart</v-list-item-title>
          </v-list-item>
          <v-list-item two-line @click="displayCheckout" :disabled="!cart.items">
            <v-list-item-content>
              <v-list-item-title>Checkout</v-list-item-title>
              <v-list-item-subtitle>Total USD: {{ total }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-badge class="mx-4" color="appBarTx appBarBg--text">
        <template v-slot:badge>{{ cart.items }}</template>
        <v-icon color="appBarTx">mdi-shopping-outline</v-icon>
      </v-badge>
      
      <v-divider
        class="mx-4"
        vertical
      ></v-divider>
      

      <v-icon
        class="align-center appBarTx--text"
        @click="toggleTheme"
      >mdi-invert-colors</v-icon>
    </v-app-bar>

    <router-view />

    <v-footer
      app
      class="justify-space-between"
    >
      <span class="px-1">&copy; {{ new Date().getFullYear() }}</span>
      <a class="primary--text" style="text-decoration: none;" href="https://radionica.digital" target="_blank"><small>radionica.digital</small></a>
    </v-footer>
  </v-app>
</template>

<style lang="scss">
#app {
  font-family: 'Helvetica', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}

.v-app-bar {
  .v-input__slot {
    margin-top: 25px;
  }
}

.v-dialog {
  .v-list {
    .v-list-item {
      border-bottom: 1px dotted #c1c1c1;
      &:last-child {
        border-bottom: 0px none;
      }
    }
  }
}

</style>

<script>
  export default {
    data(){
      return {
        drawer: this.$store.getters['layout/drawer'],
        cart: this.$store.getters['cart/cart'],
        
      }
    },
    computed: {
      total: function() {
        if (!this.cart.items) {
          return 0;
        }

        let total = [];

        Object.entries(this.cart.products).forEach(([key, val]) => {
            let price = this.$store.getters['shop/shop'].products[key].price

            total.push(val*price)
        });

        return total.reduce(function(total, num){ return total + num }, 0).toFixed(2);
        
      },
      // system
      isLoggedIn : function(){ return this.$store.getters['system/isLoggedIn']}
    },
    methods: {
      // checkout
      displayCheckout() {
        this.$store.dispatch('shop/displayCheckout')
      },
      // cart
      displayCart() {
        this.$store.dispatch('shop/displayCart')
      },
      resetCart() {
        this.$store.dispatch('cart/resetCart')
      },
      // layout 
      toggleTheme() {
        this.$store.dispatch('layout/toggleTheme', this.drawer.theme)
        this.$vuetify.theme.dark = this.drawer.theme
      },
      // system
      logout: function () {
        this.$store.dispatch('system/logout')
        .then(() => {
          this.$router.push('/login')
        })
      }
    },
    created: function () {
      this.$vuetify.theme.dark = this.drawer.theme

      
    }
  }
</script>
